import React, { useContext, useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, CircularProgress, Autocomplete, IconButton, Chip } from '@mui/material';
import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material';

import DrawerContext from '../../../context/DrawerContext';
import AuthContext from '../../../context/AuthContext';
import CustomButton from '../../../common/CustomButton';

function AddCategory({ drawerDetails }) {

  console.log(drawerDetails.value);
  const authCtx = useContext(AuthContext);
  const drawerCtx = useContext(DrawerContext);

  const [categoryName, setCategoryName] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [categories, setCategories] = useState([]);
  const [mainCategory, setMainCategory] = React.useState('');
  const [mappedParents, setMappedParents] = useState([]);

  const getAllCategories = () => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URI}/v3/categories`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
    })
      .then(response => {
        return response.json();
      }).then(data => {
        if (data.status === 'success') {
          setLoading(false)
          setCategories(data?.data || []);
        } else {
          console.error("API Error:", data.message || "Failed to fetch categories");
          setLoading(false);
        }
      }).catch(err => {
        console.error("Error fetching categories:", err);
        setLoading(false);
      });

  }  

  const handleChange = (event) => {
    setMainCategory(event.target.value);
  };

  useEffect(() => {
    getAllCategories();
    if (drawerDetails?.type?.toLowerCase() === "edit") {

      setCategoryName(drawerDetails?.value?.title || "");
      setFile(drawerDetails?.value?.icon || null);

      if (drawerDetails?.priority === "sub") {
        setMainCategory(drawerDetails?.value?.categoryId || "");
        // Set mapped parents if they exist
        if (drawerDetails?.value?.mappedParents) {
          setMappedParents(drawerDetails.value.mappedParents);
        }
      }

    }
  }, [drawerDetails]);

  const saveCategory = () => {

    // Validation checks
    if (!categoryName.trim()) {
      console.error("Category name is required");
      return;
    }

    if (drawerDetails?.value?.categoryId && !mainCategory) {
      console.error("Main category is required for subcategories");
      return;
    }

    setIsSaving(true);

    const payload = {
      isMainCat: !drawerDetails?.value.categoryId ? true : false,
      categoryTitle: categoryName.trim(),
      mainCategorySelected: mainCategory,
      ...(mappedParents.length > 0 && { mappedParents: mappedParents })
    };

    console.log(payload);

    try {
      fetch(`${process.env.REACT_APP_API_URI}/v3/admin/category/${drawerDetails?.value.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authCtx.token,
        },
        body: JSON.stringify(payload),
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.status === "success") {
          drawerCtx.setPageUpdate({page: "categories"});
          drawerCtx.closeDrawer();
          setIsSaving(false);
        } else {
          console.error("API Error:", data.message || "Unknown error occurred");
          setIsSaving(false);
        }
      })
      .catch((error) => {
        console.error("Network or API error:", error);
        setIsSaving(false);
      });
    } catch (error) {
      console.log("error : ", error);
      setIsSaving(false);
    }

  }

  const addMappedParent = () => {
    setMappedParents([...mappedParents, { parentId: '', parentTitle: '' }]);
  };

  const removeMappedParent = (index) => {
    const updatedParents = mappedParents.filter((_, i) => i !== index);
    setMappedParents(updatedParents);
  };

  const handleMappedParentChange = (index, newValue) => {
    const updatedParents = [...mappedParents];
    updatedParents[index] = { parentId: newValue.id, parentTitle: newValue.title };
    setMappedParents(updatedParents);
  };

  const getAvailableMappedParents = () => {
    const selectedIds = mappedParents.map(parent => parent.parentId).filter(id => id);
    return categories.filter(cat => !selectedIds.includes(cat.id) && cat.id !== mainCategory);
  };

  return (
    <div className="container">
      <div className="drawer">

        <header>
          <h1 style={{}} data-aos="fade-right" data-aos-delay="500">UPDATE "{categoryName.toUpperCase()}" CATEGORY</h1>
        </header>

        <section className='add-category-content' >

          <h3>Update your <strong>Category</strong></h3><br/>

          <TextField 
            id="outlined-basic" 
            fullWidth 
            label={"Main Category Name"} 
            value={categoryName} 
            onChange={(e) => setCategoryName(e.target.value)} 
          />

          {/* { 
            !drawerDetails?.value.categoryId ? <>
              
            </> : <>
              <Autocomplete
                 options={categories}
                 getOptionLabel={(option) => option.title}
                 value={categories.find(cat => cat.id === mainCategory) || null}
                 onChange={(event, newValue) => {
                   setMainCategory(newValue ? newValue.id : '');
                 }}
                 filterOptions={(options, { inputValue }) => {
                   if (!inputValue) return options;
                   return options.filter((option) =>
                     option.title.toLowerCase().includes(inputValue.toLowerCase())
                   );
                 }}
                 renderInput={(params) => (
                   <TextField
                     {...params}
                     label="Select Main Category"
                     placeholder={loading ? "Loading categories..." : "Search main categories..."}
                     disabled={loading}
                   />
                 )}
                 renderOption={(props, option) => (
                   <li {...props} key={option.id}>
                     {option.title}
                   </li>
                 )}
                 isOptionEqualToValue={(option, value) => option.id === value?.id}
                 loading={loading}
                 fullWidth
               />
              <br/>
              <TextField 
                id="outlined-basic" 
                fullWidth 
                label={drawerDetails.type == "create" ? "Sub Category Name" : "Main Category Name"} 
                value={categoryName} 
                onChange={(e) => setCategoryName(e.target.value)} 
              />
            </>
          } */}

        </section>

        <footer>
          <CustomButton onClick={() => drawerCtx.closeDrawer()} className="cancel">Cancel</CustomButton>
          <CustomButton 
            onClick={() => saveCategory()} 
            variant="contained" 
            disabled={
              isSaving || 
              !categoryName.trim() ||
              (drawerDetails?.value?.categoryId && !mainCategory)
            }
          >
            {isSaving ? <CircularProgress style={{ color: "#fff" }} size={20} /> : "Save Changes" }
          </CustomButton>
        </footer>

      </div>
    </div>
  );

}
export default AddCategory;
